import React from 'react';
import { Card, Typography } from 'antd';
import { useAuth } from '../Context';
import AgregarEquipo from './AgregarEquipo';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const AgregarEquipoPage = () => {
  const { sucursal } = useAuth();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/sistema/equipo/buscar');
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
          Registrar Nuevo Equipo
        </Title>
        <AgregarEquipo 
          equipo={null}
          sucursal={sucursal}
          onClose={handleClose}
        />
      </Card>
    </div>
  );
};

export default AgregarEquipoPage;
